import React from "react";
import { Col, Container, Row } from "reactstrap";

const ReturnAndRefundMetrics = () => {
  const data = [
    { metric: "Return Rate", value: "5%" },
    { metric: "Refund Rate", value: "3%" },
    { metric: "Average Return Processing Time", value: "10 Hours" },
    { metric: "Average Refund Processing Time", value: "10 Hours" },
    { metric: "Percentage of Returns Approved", value: "90%" },
    { metric: "Percentage of Refunds Approved", value: "83.3%" },
    { metric: "Return Cost", value: "$5" },
    { metric: "Refund Cost", value: "$5" },
  ];

  const refundReasonsData = [
    { metric: "Damaged", value: "40%" },
    { metric: "Incorrect", value: "30%" },
    { metric: "Size/Color", value: "20%" },
    { metric: "Other", value: "10%" },
  ];

  return (
    <div>
      <h4 className="fw-semibold my-3">Return and Refund Metrices</h4>

      <Row className="g-0 row-gap-3">
        <Col xl={6} className="pe-xl-3">
          <Row
            className="g-0 fw-semibold py-2 px-3"
            style={{
              backgroundColor: "#EC7426",
              color: "#ffffff",
              borderTopRightRadius: ".5rem",
              borderTopLeftRadius: ".5rem",
              fontSize: "1.25rem",
            }}
          >
            <Col xs="8" className="pe-2">Metric</Col>
            <Col xs="4" className="ps-4">Value</Col>
          </Row>
          <Container
            fluid
            className="g-0 p-3 bg-white fw-medium"
            style={{
              borderBottomRightRadius: ".5rem",
              borderBottomLeftRadius: ".5rem",
            }}
          >
            {data.map((item, index) => (
              <Row key={index} className="g-0">
                <Col xs="8" className="pe-2" style={{ borderInlineEnd: "1px solid #D9D9D9" }}>
                  {item.metric}
                </Col>
                <Col xs="4" className="ps-4" style={{ color: "#EC7426" }}>
                  {item.value}
                </Col>
              </Row>
            ))}
          </Container>
        </Col>

        <Col xl={3} className="d-flex flex-column px-xl-3">
          <div
            style={{
              backgroundColor: "#FBBD34",
              color: "white",
              padding: "0.5rem 1rem",
              borderTopRightRadius: ".5rem",
              borderTopLeftRadius: ".5rem",
              textAlign: "center",
              fontSize: "1.25rem",
              fontWeight: "600",
            }}
          >
            <p className="m-0 lh-base">Refund Reasons</p>
          </div>
          <Container fluid className="g-0 py-3 px-3 px-xxl-4 bg-white fw-medium">
            {refundReasonsData.map((item, index) => (
              <Row key={index} className="g-0">
                <Col xs="8" className="pe-2">{item.metric}</Col>
                <Col xs="4" style={{ color: "#EC7426" }}>
                  {item.value}
                </Col>
              </Row>
            ))}
          </Container>
          <Container
            fluid
            className="g-0 p-3 bg-white fw-medium flex-fill d-flex align-items-center justify-content-center"
            style={{
              borderBottomRightRadius: ".5rem",
              borderBottomLeftRadius: ".5rem",
            }}
          >
            Ring graph
          </Container>
        </Col>

        <Col xl={3} className="d-flex flex-column ps-xl-3">
          <div
            style={{
              backgroundColor: "#FBBD34",
              color: "white",
              padding: "0.5rem 1rem",
              borderTopRightRadius: ".5rem",
              borderTopLeftRadius: ".5rem",
              textAlign: "center",
              fontSize: "1.25rem",
              fontWeight: "600",
            }}
          >
            <p className="m-0 lh-base">Refund Reasons</p>
          </div>
          <Container fluid className="g-0 py-3 px-3 px-xxl-4 bg-white fw-medium">
            {refundReasonsData.map((item, index) => (
              <Row key={index} className="g-0">
                <Col xs="8" className="pe-2">{item.metric}</Col>
                <Col xs="4" style={{ color: "#EC7426" }}>
                  {item.value}
                </Col>
              </Row>
            ))}
          </Container>
          <Container
            fluid
            className="g-0 p-3 bg-white fw-medium flex-fill d-flex align-items-center justify-content-center"
            style={{
              borderBottomRightRadius: ".5rem",
              borderBottomLeftRadius: ".5rem",
            }}
          >
            Ring graph
          </Container>
        </Col>
      </Row>

      <Row className="g-0 mt-3 row-gap-3">
        <Col xl={6} className="pe-xl-3">
          <div className="bg-white rounded p-4 pb-5 text-center">
            Return Rate and Refund Rate Bar Chart
          </div>
        </Col>
        <Col xl={6} className="ps-xl-3">
          <div className="bg-white rounded p-4 pb-5 text-center">
            Reasons Breakdown Pie Charts
          </div>
        </Col>
      </Row>

      <Row className="g-0 mt-3">
        <Col xl={6} className="pe-xl-3">
          <div className="bg-white rounded p-4 pb-5 text-center">
            Average Processing Time Line Graph
          </div>
        </Col>
      </Row>

    </div>
  );
};

export default ReturnAndRefundMetrics;